import {
	gridGutter,
	fontSize20,
	gridGutter1q6,
	fontSize18,
	fontSize12,
	fontSize16
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import theme from '../../../../js/shared/new-theme';
import { transparentize } from 'polished'

export const defaultStyle = `
	position: absolute;
	width: 100%;
	height: 100%;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${transparentize(0.3, theme.palette.common.black)};
	z-index: 99999;

	&.enter {
		opacity: 0;

		&-active {
			opacity: 1;
			transition: all 300ms ease-in;
			transform: translateX(0px);
		}
	}

	&.exit {
		opacity: 1;

		&-active {
			opacity: 0;
			transition: all 300ms ease-in;
		}
	}
`;

export const contentStyle = `
	position: absolute;
	margin: auto;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: white;
	padding: ${gridGutter}px;
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	@media (max-width: 415px) {
		width: 95% !important;
		height: 370px;
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
}
`;

export const middleStyle = `
position: relative;
width: 100%;
height: 100%;
display: block;
transform: translateY(-50%) !important;
top: 50% !important;
left: 0;
right: 0;
bottom: 0;
background: rgba(63, 63, 63, 0.6);
z-index: 99999;

&.enter {
	opacity: 0;

	&-active {
		opacity: 1;
		transition: all 300ms ease-in;
		transform: translateX(0px);
	}
}

&.exit {
	opacity: 1;

	&-active {
		opacity: 0;
		transition: all 300ms ease-in;
	}
}
`;

export const titleStyle = `
	font-size: ${fontSize20};
	font-weight: bold;
	color: ${theme.palette.gray[800].value};

	&.text-center {
		text-align: center;
	}

	@media (max-width: 415px) {
		font-size: ${fontSize16};
	}

`;

export const descriptionStyle = `
	color: ${theme.palette.gray[600].value};
`;

export const buttonStyle = `
	padding: ${gridGutter * 1.5}px 0 0;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
	align-items: flex-start;
	@media (max-width: 415px) {
		padding: ${gridGutter1q6}px 0 0;
	}

	button {
		font-size: ${fontSize18};
		flex: 1;
		padding: 12px;

		&:first-child {
			margin-right: 10px;
		}

		&:last-child {
			margin-left: 10px;
		}

		@media (max-width: 415px) {
			font-size: ${fontSize12};
		}
		@media (max-width: 340px) {
			font-size: ${fontSize12};
		}
	}
`;
